// Warning: these routes are currently only used in the vertical nav, changing them will not affect other routes in the app

export const routes = {
  home: "/",
  notices: "/notices",
  noticesV2: "/noticesv2",
  noticesEmptyState: "/notices?showNoView=true",
  noticeAnalysis: "/notices/analysis",
  frameworks: "/frameworks",
  spend: "/spend",
  documents: "/documents",
  documentsEmptyState: "/documents?showNoView=true",
  contacts: "/contacts",
  buyer: "/buyers",
  buyers: "/buyers/all-buyers",
  supplier: "/suppliers",
  suppliers: "/suppliers/search",
  leads: "/leads",
  bids: "/bids",
  bidResponses: "/bid_responses",
  noticeLists: "/notices/lists",
  buyerLists: "/buyers/lists",
  customBriefings: "/reports/custom",
  industryReports: "/reports/industry",
  settings: "/account-management/feed-settings",
  contentLibrary: "/content-library",
  savedSearches: "/search/saved",
  help: "https://help.stotles.com/",
  signIn: "/auth/login",
  signUp: "/auth/register",
};

// Parametrised route path templates for type-safe SPA links (`<Button to=>` / `navigate`).
// `as const` preserves the literal types, so each value is validated against the router's
// route tree at compile time (a typo'd path won't satisfy TanStack's `to`).
export const routePaths = {
  bidDetail: "/bids/$id",
  leadDetail: "/leads/$id",
} as const;

export const routeSegments = {
  bidQualification: "bid_qualification",
  requirementSummary: "requirement-summary",
  qualificationReport: "qualification-report",
  buyerActivity: "buyer-activity",
  winThemes: "win-themes",
  bidSelfServe: "bid-self-serve",
};

export const settingsRoutes = {
  signalSettings: "/account-management/feed-settings",
  account: "/account-management/account",
  security: "/account-management/security",
  subscription: "/account-management/subscription",
  bidSelfServe: "/account-management/bid-self-serve",
  notifications: "/account-management/notifications",
  team: "/account-management/my-team",
  usage: "/account-management/usage",
  integrations: "/account-management/integrations",
  leadStages: "/account-management/lead-stages",
  bidStages: "/account-management/bid-stages",
  toneOfVoice: "/account-management/tone-of-voice",
  qualificationReport: "/account-management/qualification-report",
  quickPrompts: "/account-management/quick-prompts",
  cognismToken: "/account-management/cognism-token",
  contacts: "/account-management/contacts",
  sso: "/account-management/sso",
};

export const contentLibraryRoutes = {
  uploads: "/content-library/uploads",
  googledrive: "/content-library/googledrive",
  sharepoint: "/content-library/sharepoint",
  toReview: "/content-library/to-review",
  unassigned: "/content-library/unassigned",
};

export const isOnListsPath =
  window.location.pathname.includes(routes.noticeLists) ||
  window.location.pathname.includes(routes.buyerLists);
export const isOnReportsPath = window.location.pathname.includes("/reports");
export const isOnSettingsPath = window.location.pathname.includes("/account-management");
